/* eslint-disable no-nested-ternary */
import styled from 'vue-styled-components';

import theme from '@/config/theme';

export const IconTypes = ['chevron-left', 'options'] as const;
export const ContentTypes = ['territory', 'monitoring'] as const;

const tableProps = {
  count: Number,
  current: String,
};

export type TableProps = {
  count: number;
  current: string;
};

export const WrapperTableHeader = styled('header', tableProps)`
  ${`
    display: grid;
    grid-template-columns: 1.8fr 2fr 2.5fr 1.5fr 1fr;
    margin-bottom: 14px;
    padding-left: 18px;
    padding-right: 18px;
    aling-items: center;

    .icon {
      align-items: center;
      color: ${theme.colors.gray5};
      font-size: ${theme.font.sizes.p3};

      a {
        align-items: center;
        display: inline-flex;
      }

      img.filter {
        margin-left: ${theme.spacings.small};
      }

      img.ordenation {
        display: block;
        margin-left: ${theme.spacings.small};
      }

      &:hover {

        img.ordenation {
          display: block;
        }
      }
    }
  `}
`;

export const DivFlex = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px 20px;
  @media screen and (max-width: 1300px) {
    gap: 20px 40px;
  }
  &:not(:first-child) {
    margin: .9rem
  }
`;

export const WrapperTable = styled('a', tableProps)`
  ${`
    align-items: center;
    background-color: ${theme.border.radius.small};
    border: 4px solid transparent;
    border-radius: ${theme.border.radius.small};
    box-shadow: ${theme.shadow.lv1};
    color: '#40433E';
    display: grid;
    font-size: 0.700em;
    grid-template-columns: 1.8fr 1.8fr 3fr 1.9fr 0.8fr;
    padding: ${theme.spacings.medium} ${theme.spacings.large};
    position: relative;
    pointer-events: none;
    min-width: 500px;
    max-width: 500%;

    &.active {
      pointer-events: auto;
    }

    &:hover {
      border-color: ${theme.colors.secondaryAlpha20};
      box-shadow: ${theme.shadow.lv2};

      .icon {
        color: ${theme.colors.secondary};
      }
    }

    .icon {
      align-items: center;
      color: ${theme.colors.gray4};
      display: flex;
      height: 20px;
      justify-content: center;
      position: absolute;
      right: ${theme.spacings.large};
      width: 20px;

      .active {
        color: ${theme.colors.secondaryDark};
      }

      img {
        display: block;
      }
    }
  `}
`;

export const WrapperTableMain = styled('main', tableProps)`
  ${`

    div.line {

      ${WrapperTable}

      & ~ div {
        margin-top: ${theme.spacings.xsmall};
      }
    }
  `}
`;

export const TerritoryCard = styled.div`
  height: 369px;
  width: 290px;
  @media screen and (max-width: 1300px) {
    width: 350px;
  }
  border-radius: 8px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  &:hover {
    cursor: pointer;
    border: 3px solid ${theme.colors.secondaryAlpha20};
    box-shadow: ${theme.shadow.lv2};
  }

  position: relative;

  img{
    height: 156px;
    width: 100%;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .p-first{
    word-break: break-all;
    font-size: 16px;
    font-family: 'Roboto';
    font-weight: 500;
    line-height: 28px;
  }
  .card-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 257px;
    position: absolute;
    left: 20px;
    top: 50.7%;
  }
  p{
    font-size: 14px;
    color: #40433E;
    font-family: 'Proxima Nova', sans-serif;
    line-height: 24px;
    &:not(:last-child) {
      margin-bottom: 4px;
    }
  }
`;
